class VideoSwitcher extends HTMLElement {
  connectedCallback() {
    this.desktop = this.querySelector('video.js-video-desktop');
    this.mobile = this.querySelector('video.js-video-mobile');

    if (!this.desktop || !this.mobile) return;

    this.mediaQuery = window.matchMedia('(min-width: 750px)');
    this._onChange = this._onChange.bind(this);
    this.mediaQuery.addEventListener('change', this._onChange);
    this._pauseInactive();
  }

  disconnectedCallback() {
    this.mediaQuery?.removeEventListener('change', this._onChange);
  }

  _pauseInactive() {
    const inactive = this.mediaQuery.matches ? this.mobile : this.desktop;
    inactive.pause();
    inactive.currentTime = 0;
  }

  _onChange(e) {
    const outgoing = e.matches ? this.mobile : this.desktop;
    const incoming = e.matches ? this.desktop : this.mobile;

    outgoing.pause();
    outgoing.currentTime = 0;

    if (incoming.autoplay) incoming.play();
  }
}

customElements.define('video-switcher', VideoSwitcher);
